const SystemDataEvent = {
  CHANGED: 'systemDataChanged',
};

export default SystemDataEvent;
